"use client";

import FormHolder from "../../../../components/Form/FormHolder";

const SiteSettingsThemeScreen = () => {
  return (
    <>
      <title>Site Theme</title>
      <FormHolder>
        <h4 className="font-medium text-xl text-white">Choose Theme</h4>
        <p className="text-sm font-light text-gray-200">
          Project Theme selection coming soon, check our{" "}
          <a
            href="https://appsicle.co/blog"
            target="_blank"
            rel="noreferrer noopener"
            className="text-primary font-bold"
          >
            blog
          </a>{" "}
          for updates.
        </p>
      </FormHolder>
    </>
  );
};

export default SiteSettingsThemeScreen;
